import type { ReservationItem } from '@/root/shared-types/reservation/reservation-types'

export const isUserVisibleItem = (item: ReservationItem): boolean => !item.internal && item.type !== 'FEE'

export const isPromotionItem = (item: ReservationItem): boolean => item.promotion !== undefined

export const isTicketItem = (item: ReservationItem): boolean => isUserVisibleItem(item) && !isPromotionItem(item)
